function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 144 163 L 595.199219 163 L 595.199219 595.199219 L 144 595.199219 Z M 144 163 "
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)",
  clipRule: "nonzero",
  transform: "matrix(1, 0, 0, 1, -127, -141)"
});

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 3.473 336.493 316.004",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _ref3, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fillOpacity: 1,
      fill: "rgb(30, 166, 230)"
    },
    d: "M 280.594 138.848 C 301.313 133.621 316.648 114.855 316.648 92.504 C 316.648 66.102 295.262 44.703 268.879 44.703 C 242.5 44.703 221.113 66.102 221.113 92.504 C 221.113 114.82 236.398 133.563 257.066 138.824 C 227.43 147.586 204.984 188.941 204.984 238.648 C 204.984 260.559 209.348 280.852 216.762 297.441 L 320.82 297.441 C 328.238 280.852 332.602 260.559 332.602 238.648 C 332.602 188.984 310.195 147.656 280.594 138.848"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fillOpacity: 1,
      fill: "rgb(241, 80, 41)"
    },
    d: "M 80.609 138.848 C 101.328 133.621 116.664 114.855 116.664 92.504 C 116.664 66.102 95.277 44.703 68.898 44.703 C 42.516 44.703 21.129 66.102 21.129 92.504 C 21.129 114.82 36.414 133.563 57.086 138.824 C 27.445 147.586 5 188.941 5 238.648 C 5 260.559 9.363 280.852 16.777 297.441 L 120.836 297.441 C 128.254 280.852 132.617 260.559 132.617 238.648 C 132.617 188.984 110.211 147.656 80.609 138.848"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fillOpacity: 1,
      fill: "rgb(181, 220, 23)"
    },
    d: "M 183.008 121.176 C 208.336 114.789 227.086 91.855 227.086 64.535 C 227.086 32.273 200.941 6.121 168.691 6.121 C 136.441 6.121 110.301 32.273 110.301 64.535 C 110.301 91.813 128.988 114.719 154.254 121.148 C 118.02 131.855 90.582 182.398 90.582 243.145 C 90.582 269.926 95.914 294.723 104.98 315 L 232.184 315 C 241.254 294.723 246.586 269.926 246.586 243.145 C 246.586 182.449 219.195 131.941 183.008 121.176"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c6bfc79f.svg";
export { ForwardRef as ReactComponent };